// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  IPageDataTripReviewsRequest,
  TPageDataTripReviewsModel,
  IMappers,
  TPageDataTripReviewsResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IPublicV1PageDataTripReviewsResponse } from '../../../entities/response/PublicV1PageDataTripReviewsResponse';
import type { IErrorResponseSchema } from '../../../entities/schemas/ErrorResponseSchema';

export function createPageDataTripReviewsModel(parameters: IPageDataTripReviewsRequest): TPageDataTripReviewsModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'dailyrent',
    pathApi: '/v1/page-data/trip-reviews/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IPageDataTripReviewsOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IPageDataTripReviewsRequest;
}

export async function fetchPageDataTripReviews<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IPageDataTripReviewsOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TPageDataTripReviewsResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createPageDataTripReviewsModel(parameters),
    config,
  )) as FetchResponse<TPageDataTripReviewsResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IPublicV1PageDataTripReviewsResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TPageDataTripReviewsResponse>;
}
